import { z } from 'zod';

import { alertSeveritySchema } from './console.js';

/** Config de empresa: reglas de alertas, expectativas de heartbeats e impersonación. */

const isoDate = z.string();

// ------------------------------------------------------------------ reglas de alertas

export const alertRuleConfigSchema = z.object({
  enabled: z.boolean(),
  severity: alertSeveritySchema,
  cooldownMinutes: z.number().int(),
  channels: z.record(z.string(), z.boolean()),
  params: z.record(z.string(), z.unknown()),
});

export const alertRuleViewSchema = z.object({
  ruleKey: z.string(),
  /** Qué rige hoy para la empresa (empresa > agencia > incorporada). */
  effective: alertRuleConfigSchema,
  source: z.enum(['builtin', 'agency', 'tenant']),
  tenantOverride: alertRuleConfigSchema.nullable(),
});
export type AlertRuleView = z.infer<typeof alertRuleViewSchema>;

export const upsertAlertRuleSchema = z.object({
  enabled: z.boolean(),
  severity: alertSeveritySchema,
  cooldownMinutes: z
    .number()
    .int()
    .min(1)
    .max(7 * 24 * 60),
  channels: z.record(z.string(), z.boolean()).default({ telegram: true }),
  params: z.record(z.string(), z.union([z.number(), z.string(), z.boolean()])).default({}),
});
export type UpsertAlertRule = z.input<typeof upsertAlertRuleSchema>;

// ------------------------------------------------------------------ heartbeats

export const heartbeatConfigSchema = z.object({
  id: z.uuid(),
  jobKey: z.string(),
  expectedIntervalSeconds: z.number().int(),
  graceSeconds: z.number().int(),
  enabled: z.boolean(),
  lastSeenAt: isoDate.nullable(),
  lastStatus: z.enum(['success', 'error', 'warning']).nullable(),
  overdue: z.boolean(),
});
export type HeartbeatConfig = z.infer<typeof heartbeatConfigSchema>;

export const jobKeySchema = z
  .string()
  .trim()
  .regex(/^[a-z0-9][a-z0-9._:-]{0,99}$/, { error: 'Sólo minúsculas, números, punto, guion y :' });

export const createHeartbeatSchema = z.object({
  jobKey: jobKeySchema,
  expectedIntervalSeconds: z
    .number()
    .int()
    .min(60)
    .max(31 * 24 * 3600),
  graceSeconds: z
    .number()
    .int()
    .min(0)
    .max(7 * 24 * 3600)
    .default(300),
  enabled: z.boolean().default(true),
});
export const updateHeartbeatSchema = createHeartbeatSchema.omit({ jobKey: true }).partial();

// ------------------------------------------------------------------ Instantly: rotar API key

export const rotateInstantlyKeySchema = z.object({ apiKey: z.string().min(10).max(500) });
